import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles((theme) => ({
  photo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },

  container: {
    marginTop: theme.spacing.sm,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },

  name: {
    fontWeight: 600,
    textAlign: 'center',
    lineHeight: '20px'
  },

  email: {
    color: theme.colors.brandGray[0],
    fontSize: '14px',
    textAlign: 'center',
    lineHeight: '17px',
    marginTop: theme.spacing.xs
  },

  badge: {
    marginTop: theme.spacing.sm
  },
  ldapLabel: {
    backgroundColor: 'rgba(51, 154, 240, 1)',
    color: '#EFF8FF',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '18px',
    padding: '2px 8px',
    borderRadius: '16px',
    flexShrink: 0
  }
}));
